import axios from 'axios';
export const getTime = () => {
	return axios
		.get(`${process.env.REACT_APP_API}/get-timer`)
};